import React from "react";
import NewsSectionCard from "../cards/NewsSectionCard";

// Style \\
import "../../assets/styles/sections/newsSection.scss";

// Icons \\
import News from "../news/News";
import RecentPost from "../cards/RecentPost";
import RecentPostModal from "../modal/RecentPostModal";

const NewsSection = () => {
  return (
    <section className="newsSection">
      <div className="container">
        {/* <RecentPostModal /> */}
        <div className="newsSection_items">
          <div className="newsSection_items_newsCard_box">
            <NewsSectionCard />
            <NewsSectionCard />
            <NewsSectionCard />
          </div>

          <div className="box">
            <RecentPost />
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
